import Validator from "./validator"

const Storage = {

    setValue: (key, value) => {
        if (Validator.start(key)) {
            localStorage.setItem(key, value)
        } else {
            console.error(`key is null or undefined`)
        }
    },

    getValue: (key) => {
        if (Validator.start(key)) {
            return localStorage.getItem(key)
        } else {
            return null
        }
    },

    setObject: (key, object) => {
        if (Validator.start(key, object)) {
            localStorage.setItem(key, JSON.stringify(object))
        } else {
            console.error(`key or object are null or undefined`)
        }
    },

    getObject: (key) => {
        if (key) {
            if (Validator.start(localStorage.getItem(key))) {
                return JSON.parse(localStorage.getItem(key))
            } else {
                return null
            }
        }
    },

    remove: (key) => {
        if (key) {
            localStorage.removeItem(key)
        } else {
            console.error(`key is null or undefined`)
        }
    },

    removeAll: () => {
        // remueve todos los datos de la aplicación guardadas en el localStorage
        localStorage.clear()
    }

}

export default Storage